<div class="p-field-acr p-mb-4">
    <label for="input_{{ cid }}" id="label_{{ cid }}">{{ label }}</label>
    <div class="p-inputgroup" *ngIf="edit !== true">
      <div *ngIf="basevalue === null || basevalue === ''" aria-labelledby="label_{{ cid }}">-</div>
      <div *ngIf="basevalue !== null && basevalue !== '' && type !== 'textarea'" aria-labelledby="label_{{ cid }}">{{ basevalue }}</div>
      <div *ngIf="basevalue !== null && basevalue !== '' && type === 'textarea'" [innerHtml]="basevalue | nl2br" aria-labelledby="label_{{ cid }}"></div>
    </div>
    <div class="p-inputgroup" *ngIf="edit === true" [ngSwitch]="type">
      <div *ngSwitchCase="'input'">
        <input #field [formControl]="control" id="input_{{ cid }}" type="text" pInputText aria-labelledby="label_{{ cid }}" />
      </div>
      <div *ngSwitchCase="'password'">
        <input #field [formControl]="control" id="input_{{ cid }}" type="password" pPassword autocomplete="new-password" [feedback]="false" aria-labelledby="label_{{ cid }}" />
      </div>
      <div *ngSwitchCase="'textarea'">
        <textarea #field [formControl]="control" id="input_{{ cid }}" [rows]="controlConfig.rows" pInputTextarea [autoResize]="controlConfig.autoResize" aria-labelledby="label_{{ cid }}"></textarea>
      </div>
      <div *ngSwitchCase="'select'">
        <p-dropdown [formControl]="control" id="input_{{ cid }}" [options]="options" [optionLabel]="optionlabel" [placeholder]="'--- bitte wählen ---'" [autoDisplayFirst]="false" aria-labelledby="label_{{ cid }}"></p-dropdown>
      </div>
      <div *ngSwitchCase="'multiselect'">
        <p-multiSelect [formControl]="control" id="input_{{ cid }}" [options]="options" [optionLabel]="optionlabel" [filter]="false" aria-labelledby="label_{{ cid }}"></p-multiSelect>
      </div>
      <div *ngSwitchCase="'date'">
        <p-calendar [formControl]="control" id="input_{{ cid }}" showTime="true" hourFormat="24" dateFormat="dd.mm.yy" [minDate]="minDate" aria-labelledby="label_{{ cid }}" aria-describedby="aria_date"></p-calendar>
      </div>
      <div *ngSwitchCase="'time'">
        <p-calendar [formControl]="control" id="input_{{ cid }}" showTime="true" hourFormat="24" [timeOnly]="true" [readonlyInput]="readonlyInput" (onSelect)="onSelect()" aria-labelledby="label_{{ cid }}"></p-calendar>
      </div>
      <div *ngSwitchCase="'slider'" class="p-grid">
        <div class="p-col p-pt-3">
          <p-slider [formControl]="control" id="input_{{ cid }}" [min]="min" [max]="max" [step]="step" aria-labelledby="label_{{ cid }}"></p-slider>
        </div>
        <div class="p-col-fixed p-text-right" style="width: 20px;">
          {{ control.value }}
        </div>
      </div>
      <app-form-error [control]="control" [label]="label"></app-form-error>
    </div>
</div>

<div class="p-d-none">
  <span id="aria_date">Bitte geben Sie ein Datum ein!</span>
</div>
